module.exports = __webpack_public_path__ + "img/productBgImg23.d37ea733.png";